import { render, staticRenderFns } from "./DialogAddDiscount.vue?vue&type=template&id=3212da3a"
import script from "./DialogAddDiscount.vue?vue&type=script&lang=ts"
export * from "./DialogAddDiscount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports